<button class="btn" (click)="saveFileFnFoxit()">save</button>
<button class="btn" (click)="downloadFileFnFoxit()">download</button>